import { useTranslation } from "react-i18next";
import { Button } from "~/common/components/Button/Button";
import { getPunchoutConfig } from "~/Cart/feature/Punchout/punchoutConstants";

export const PunchoutPlaceRequisition = ({ disabled }: { disabled?: boolean }) => {
  const { t } = useTranslation();

  return (
    <Button href={getPunchoutConfig().placeOrder} data-test-id={"btn-punchout-checkout"} disabled={disabled}>
      {t("page.cart.punchout.placeOrder")}
    </Button>
  );
};
export const PunchoutCancelRequisition = () => {
  const { t } = useTranslation();
  return (
    <Button variant={"text"} href={getPunchoutConfig().cancel}>
      {t("page.cart.punchout.cancelOrder")}
    </Button>
  );
};
